import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubSink } from 'subsink';
import {
  IUserAllied,
  UserAlliedService,
} from 'src/app/services/user-allied.service';

@Component({
  selector: 'app-list-user-allieds',
  templateUrl: './list-user-allieds.component.html',
  styleUrls: ['./list-user-allieds.component.scss'],
})
export class ListUserAlliedsComponent implements OnInit, OnDestroy {
  @Input() public organizationIndex: string;

  private subs = new SubSink();

  public dataSource: IUserAllied[] = [];
  public isLoading: boolean = false;

  constructor(
    private userAlliedService: UserAlliedService,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.getUsersByAllied();

    this.subs.sink = this.userAlliedService.Refreshrequired.subscribe(() => {
      this.getUsersByAllied();
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public getUsersByAllied(): void {
    if (!this.organizationIndex) {
      return;
    }

    this.isLoading = true;

    this.subs.sink = this.userAlliedService
      .getUsersByAllied(this.organizationIndex)
      .subscribe({
        next: (response) => {
          this.dataSource = response?.data || [];
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.dataSource = [];

          const backendMessage =
            error?.error?.message ||
            error?.error?.errors?.[0]?.message ||
            'Ups! error al obtener usuarios';

          this._snackBar.open(backendMessage, 'cerrar', {
            duration: 4000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: 'my-snackbar-error',
          });
        },
      });
  }

  public getRoleClass(role: string): string {
    return role === 'Premium' ? 'premium-role' : 'standard-role';
  }
}
